import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { DocumentApiService } from '@api-services/document-api.service';
import { DialogNavigationServiceBase, MaybeId } from '@bases/dialog-navigation-service/dialog-navigation.service.base';
import { Document } from '@models/document';

@Injectable()
export abstract class DocumentNavigationServiceBase extends DialogNavigationServiceBase<Document> {
  constructor(protected documentApiService: DocumentApiService) {
    super();
  }

  protected override getById(documentId: MaybeId): Observable<Document | null> {
    if (!documentId) {
      return of(null);
    }
    return this.documentApiService.getDocument(documentId);
  }
}
